<ng-container>
    <div class="legends desktop">
        <div class="legend-child" *ngIf="fullyBooked">
            <span class="all-booked" > Fully Booked </span>
        </div>
        <div class="legend-child" *ngIf="OnwaitingList">
            <span class="wait-list"> Waitlist </span>
        </div>
    </div>
</ng-container>